// Robust scroll arrow management for image swatches
document.addEventListener('DOMContentLoaded', function() {
  let savedScrollPositions = new Map();
  let userScrolling = new Map(); // Track when user is actively scrolling
  let restoreOnNextUpdate = new Set(); // Track which containers need restoration
  
  function updateScrollArrows(forceRestore = false) {
    const swatchContainers = document.querySelectorAll('.product-form__input--image-swatch');
    
    swatchContainers.forEach((container, index) => {
      const scrollContainer = container.querySelector('.image-swatch-container');
      if (!scrollContainer) return;
      
      const containerKey = `swatch-${index}`;
      const isUserScrolling = userScrolling.get(containerKey);
      const shouldRestore = restoreOnNextUpdate.has(containerKey) || forceRestore;
      
      // Only restore scroll position if:
      // 1. We're forced to restore (variant change) OR marked for restoration
      // 2. User is not actively scrolling
      // 3. Position was reset to 0 and we have a saved position
      if (shouldRestore && !isUserScrolling && scrollContainer.scrollLeft === 0 && savedScrollPositions.has(containerKey)) {
        const savedPosition = savedScrollPositions.get(containerKey);
        if (savedPosition > 10) {
          scrollContainer.scrollLeft = savedPosition;
          restoreOnNextUpdate.delete(containerKey);
        }
      }
      
      const isScrollable = scrollContainer.scrollWidth > scrollContainer.clientWidth + 5; // Add small buffer
      const isAtStart = scrollContainer.scrollLeft <= 2;
      const isAtEnd = Math.abs(scrollContainer.scrollWidth - scrollContainer.clientWidth - scrollContainer.scrollLeft) < 5; // Increase tolerance
      
      // Save scroll position when user scrolls (but not if they're near the start)
      if (scrollContainer.scrollLeft > 10) {
        savedScrollPositions.set(containerKey, scrollContainer.scrollLeft);
      } else if (scrollContainer.scrollLeft <= 2) {
        // Clear saved position when user scrolls back to start
        savedScrollPositions.delete(containerKey);
      }
      
      container.classList.toggle('no-scroll', !isScrollable);
      container.classList.toggle('scrolled-to-end', isScrollable && isAtEnd);
      container.classList.toggle('scrolled-from-start', isScrollable && !isAtStart);
    });
  }
  
  // Use event delegation to handle scroll events on any image-swatch-container
  document.addEventListener('scroll', function(e) {
    if (e.target.classList.contains('image-swatch-container')) {
      // Mark user as actively scrolling
      const containers = document.querySelectorAll('.product-form__input--image-swatch');
      containers.forEach((container, index) => {
        if (container.contains(e.target)) {
          const containerKey = `swatch-${index}`;
          userScrolling.set(containerKey, true);
          
          // Clear scrolling flag after user stops
          clearTimeout(userScrolling.get(`${containerKey}-timeout`));
          userScrolling.set(`${containerKey}-timeout`, setTimeout(() => {
            userScrolling.set(containerKey, false);
          }, 150));
        }
      });
      
      updateScrollArrows();
    }
  }, true); // Use capture phase to catch all scroll events
  
  // Initial check
  updateScrollArrows();
  
  // Regular checks to handle dynamic content changes
  let checkInterval = setInterval(updateScrollArrows, 500);
  
  // More frequent checks for first 10 seconds (when variants are often changed)
  setTimeout(() => {
    clearInterval(checkInterval);
    checkInterval = setInterval(updateScrollArrows, 2000);
  }, 10000);
  
  // Check on window resize
  window.addEventListener('resize', () => {
    setTimeout(updateScrollArrows, 100);
  });
  
  // Hook into common Shopify events
  document.addEventListener('change', function(e) {
    if (e.target.matches('input[name*="id"], select[name*="id"]')) {
      setTimeout(updateScrollArrows, 200);
    }
  });
  
  // Listen for any click on variant options
  document.addEventListener('click', function(e) {
    if (e.target.closest('.product-form__input--image-swatch')) {
      // Mark all containers for restoration after variant change
      const containers = document.querySelectorAll('.product-form__input--image-swatch');
      containers.forEach((container, index) => {
        restoreOnNextUpdate.add(`swatch-${index}`);
      });
      setTimeout(() => updateScrollArrows(true), 300);
    }
  });
  
  // Comprehensive mutation observer
  const observer = new MutationObserver(() => {
    // Don't force restore on mutations, just update arrows
    setTimeout(updateScrollArrows, 100);
  });
  
  const productSection = document.querySelector('[data-section*="product"], .product-form, main');
  if (productSection) {
    observer.observe(productSection, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }
}); 